import React, { useContext } from 'react';
import { Segment } from 'semantic-ui-react';
import { getSectionClass, setItemStyleAndClass } from '../styles/formatting';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { gEnums } from '../enums/globalEnums';
import SectionHeader from '../components/sem/SectionHeader';

const GenericCard = (props) => {

  const { formData, itemProp } = props ?? {}
  const { data } = itemProp ?? {}
  const { previewType } = data ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}

  // papsContext    
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { uiSections } = aps_global ?? {}
  let { header, sectionBody, sectionHeader } = uiSections ?? {}

  switch (previewType) {
    case gEnums.previewTypes.header:
      header = formData
      break;
    case gEnums.previewTypes.sectionHeader:
      sectionHeader = formData
      break;
    case gEnums.previewTypes.sectionBody:
      sectionBody = formData
      break;
    default:
    // nothing
  }

  let { colors: colors_header } = header ?? {}
  let { colors: colors_sectionBody } = sectionBody ?? {}
  let { colors: colors_sectionHeader } = sectionHeader ?? {}

  const sac_h = {}
  const sac_sh = {}
  const sac_sb = {}

  setItemStyleAndClass(aps_global, sac_h, previewType === gEnums.previewTypes.header ? formData.colors : colors_header)
  setItemStyleAndClass(aps_global, sac_sh, previewType === gEnums.previewTypes.sectionHeader ? formData.colors : colors_sectionHeader)
  setItemStyleAndClass(aps_global, sac_sb, previewType === gEnums.previewTypes.sectionBody ? formData.colors : colors_sectionBody)

  let cn_header = previewType === gEnums.previewTypes.header ? getSectionClass('header', formData) : getSectionClass('header', header)

  const cn_sectionBody = previewType === gEnums.previewTypes.sectionBody ? getSectionClass('sec-content', sectionBody) : getSectionClass('sec-content', sectionBody)
  const cn_sectionContainer = 'sec-container sub-h ' + sectionHeader.headerDisplayType

  const headerLine = (value) => <div className="prc">
    <div className="prp-firstName">{value}</div>
  </div>

  const bodyLine = (caption, value) => <div className="prc">
    <div className="prp-l-company">{caption}{': '}</div>
    <div className="prp-company">{value}</div>
  </div>

  return <Segment>
    <div className="content card-content">
      <div className={cn_header} style={sac_h.style}>
        <div className="sec-content header">
          {headerLine('Header')}
        </div>
      </div>
      <div className={cn_sectionContainer} >
        <SectionHeader sectionHeader={{ ...formData, caption: 'Test' }} />
        <div className={cn_sectionBody} style={sac_sb.style}>
          {bodyLine('Item 1', 'Value 1')}
          {bodyLine('Item 2', 'Value 3')}
        </div>
      </div>
    </div>
  </Segment>
};

export default GenericCard